import React, { useEffect, useState, useMemo } from "react";
import {
  EditorState,
  convertFromRaw,
  convertToRaw,
} from "draft-js";
import EntityAnnotator from "./EntityAnnotator"
import { Expression } from "../../../../../model/intent/types";
import { Item, Separator, Submenu, MenuProvider } from 'react-contexify';
import 'react-contexify/dist/ReactContexify.min.css';
import { ContextMenu } from "./Styled";
import api from "../../../../../business/services/ApiManager";
import { AxiosResponse } from "axios";
import { RootState } from "../../../../../model/rootReducer";
import { useSelector } from "react-redux";

type WrapEntityAnnotatorProps = {
  value?: Expression;
};

const convertSentenceToRawContent = (expression?: Expression): any => {
  if (expression !== undefined && expression !== null) {
    var entityRanges: any[] = [];
    var entityMap = {};
    expression.tags ?.map((value, index) => {
      entityRanges.push({ offset: value.offset, length: value.length, key: index })
      // @ts-ignore
      entityMap[index] = ({
        type: "LINK",
        mutability: "IMMUTABLE",
        data: {
          entityId: value.entityId
        }
      })
    })
      return convertFromRaw({
      blocks: [
        // @ts-ignore
        {
          text: expression.text ? expression.text : '',
          type: "unstyled",
          entityRanges: entityRanges
        }
      ],
      entityMap: entityMap
    });
  } else {
    return undefined
  }
}

const WrapEntityAnnotator: React.FunctionComponent<WrapEntityAnnotatorProps> = props => {
  const botId = useSelector((state: RootState) => state.bot.selectedBot)
  var rawContent = useMemo(() => convertSentenceToRawContent(props.value), [props.value]);
  const [editorState, setEditorState] = useState<EditorState>(
    rawContent ? EditorState.createWithContent(rawContent) : EditorState.createEmpty()
  );

  useEffect(() => {
    rawContent = convertSentenceToRawContent(props.value)
    if (editorState.getDecorator()) {
      rawContent ? setEditorState(EditorState.createWithContent(rawContent, editorState.getDecorator())) : setEditorState(EditorState.createEmpty(editorState.getDecorator()))
    }
    //@ts-ignore
  }, [props.value])

  const onEditorStateChange = (editorState: EditorState) => {
    setEditorState(editorState)
  }

  const onBlur = () => {
    const currentState = editorState.getCurrentContent();
    // @ts-ignore
    props.form ?.setFieldValue(props.field ?.name, new Expression(convertToRaw(currentState)));
  }

  const onClick = (value: any) => {
    var response = api.intents.parse(botId!, props.value ? props.value.text : "");
    response.then((response: AxiosResponse<any>) => {
      if(response.status == 200){
        console.log(response)
        rawContent = convertSentenceToRawContent(response.data)
        if (editorState.getDecorator()) {
          rawContent ? setEditorState(EditorState.createWithContent(rawContent, editorState.getDecorator())) : setEditorState(EditorState.createEmpty(editorState.getDecorator()))
        }
      }
    });
  }

  // create your menu first
  const renderMenu = (menuId: string) => (
    <ContextMenu id={menuId}>
      <Item onClick={onClick}>Détection automatique des entités</Item>
    </ContextMenu>
  );

  // @ts-ignore
  const renderEntityAnnotator = () => <EntityAnnotator value={editorState} onBlur={() => onBlur()} initialData={rawContent} onChange={onEditorStateChange} />

  // @ts-ignore
  const menuId = "menu_id_" + props.field?.name;
  return (
    <>
      <MenuProvider id={menuId} style={{ width: '100%' }}>
        {renderEntityAnnotator()}
      </MenuProvider>
      {renderMenu(menuId)}
    </>

  );
};

export default WrapEntityAnnotator;
